import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import SuperTagHelper from "@/components/functionals/SuperTagHelperDashBoard.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";

export default [
  {
    prop: "DisplayObjet",
    label: "# Obj.",
    width: 100,
    sortable: true
  },
  {
    prop: "DisplayTask",
    label: "# Tr.",
    width: 80,
    sortable: true
  },
  {
    prop: "ObjetiveName",
    label: "Objetivo",
    minWidth: 180,
    sortable: true
  },
  {
    prop: "Name",
    label: "Tarea",
    minWidth: 180,
    sortable: true
  },
  {
    prop: "Status",
    label: "Estatus",
    width: 130,
    sortable: true,
    attrs: {
      tagType: "success",
      tagValue: "palomo"
    },
    formatter: SuperTagHelper
  },
  {
    prop: "ObjetiveResponsable",
    label: "Responsable Objetivo",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "ObjectiveOwnerImage"
    }
  },
  {
    prop: "Responsable",
    label: "Responsable Tarea",
    sortable: true,
    formatter: ImagePerson,
    minWidth: 200,
    attrs: {
      imgKey: "UserUrlImage"
    }
  },

  {
    prop: "InitialDate",
    label: "Fecha Inicio",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "LimitDate",
    label: "Fecha Compromiso",
    width: 200,
    sortable: true,
    formatter: CellDateTime
  },
  {
    prop: "TotalDueDays",
    label: "Días de atraso",
    width: 150,
    sortable: true
  },
  {
    prop: "Effort",
    label: "Estimación",
    width: 120,
    sortable: true
  },
  {
    prop: "PercentageProsposal",
    label: "%",
    width: 80,
    sortable: true
  }
];
